import { Component, Input } from '@angular/core';
import { QaiAlertComponent } from '@qai/ui';

@Component({
  host: {
    class: 'theme-light',
  },
  imports: [QaiAlertComponent],
  selector: 'app-call-top-alert',
  standalone: true,
  templateUrl: './call-top-alert.component.html',
  styleUrls: ['./call-top-alert.component.css'],
})
export class CallTopAlertComponent {
  @Input({ required: true }) title: string = '';
  @Input({ required: true }) message: string = '';
}
